import React from 'react';
import {List, Typography} from '@mui/material';
import ReferenceListItem from './ReferenceListItem';

/**
 * Added references tab content
 * Displays the list of existing references with evidence scores
 */
export default function AddedReferencesTab({
                                               sortedReferences,
                                               reportId,
                                               statementText,
                                               getReferenceNumber,
                                               cfg,
                                               onDeleteReference,
                                               onReplaceWithAlternative,
                                               onAddAlternativeAlongside,
                                           }) {
    if (sortedReferences.length === 0) {
        return (
            <Typography variant="body2" sx={{color: 'text.secondary', p: 2, pt: 1}}>
                No references
            </Typography>
        );
    }

    return (
        <List sx={{display: 'flex', flexDirection: 'column'}}>
            {sortedReferences.map((ref, idx) => {
                const citationNumber = getReferenceNumber(reportId, ref.localId);
                // evidenceScore may be a flat number (new structure) or an object {score, reason} (legacy)
                const evidenceScore = ref.evidenceScore != null
                    ? (typeof ref.evidenceScore === 'object'
                        ? ref.evidenceScore
                        : {score: ref.evidenceScore, reason: ref.evidenceScoreReason || null})
                    : null;

                return (
                    <ReferenceListItem
                        key={ref.localId || idx}
                        reference={ref}
                        citationNumber={citationNumber}
                        evidenceScore={evidenceScore}
                        cfg={cfg}
                        onDelete={onDeleteReference}
                        reportId={reportId}
                        statementText={statementText}
                        onReplaceWithAlternative={onReplaceWithAlternative}
                        onAddAlternativeAlongside={onAddAlternativeAlongside}
                    />
                );
            })}
        </List>
    );
}
